import { useQuery } from '@tanstack/react-query';
import { fetchAssignableGroups } from '../services/security-groups';

interface Params {
  userId: string;
  search?: string;
  page?: number;
  per_page?: number;
}

export function useAssignableGroupsQuery({ userId, search, page = 1, per_page = 200 }: Params) {
  return useQuery({
    queryKey: ['security', 'users', userId, 'assignable-groups', { search, page, per_page }],
    queryFn: () => fetchAssignableGroups(userId, { search, page, per_page }),
    enabled: Boolean(userId),
    placeholderData: (prev) => prev,
  });
}
